module.exports = __webpack_public_path__ + "img/PayPal.12b93e8e.svg";